// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';


var background = "#282a36";

var selection = "#44475a";

var foreground = "#f8f8f2";

var comment = "#6272a4";

var cyan = "#8be9fd";

var green = "#50fa7b";

var orange = "#ffb86c";

var pink = "#ff79c6";

var purple = "#bd93f9";

exports.background = background;
exports.selection = selection;
exports.foreground = foreground;
exports.comment = comment;
exports.cyan = cyan;
exports.green = green;
exports.orange = orange;
exports.pink = pink;
exports.purple = purple;
/* No side effect */
